import { useQuery } from '@hooks/reactQuery';

import { getDynamicDatesPreview } from '@api/kpi';

import { extractQueryParams } from '@utils/common';

import { IDynamicDatesRange } from '@interfaces/kpi/dto/kpiDTO';

import { EUserRoles, EVendorsValues, TVendorsValues } from '@enums/common';
import { EDynamicDateRange } from '@enums/kpi-api';

import { KPI_DYNAMIC_DATES_PREVIEW } from '@constants/queryKeys';

interface UseQueryDynamicDatesProps extends IDynamicDatesRange{
	vendor?: TVendorsValues;
}

interface UseQueryDynamicDatesReturn {
	dateRangePreview: string;
	isLoadingDateRangePreview: boolean;
}

export const useQueryDynamicDatesPreview = ({
	vendor,
	dynamicDateRange,
	startDateOffset,
}: UseQueryDynamicDatesProps): UseQueryDynamicDatesReturn => {
	const {
		data,
		isLoading: isLoadingDynamicDatesPreview,
		isFetching: isFetchingDynamicDatesPreview,
	} = useQuery({
		queryKey: [KPI_DYNAMIC_DATES_PREVIEW, { dynamicDateRange, startDateOffset }],
		queryFn: extractQueryParams(getDynamicDatesPreview),
		enabled: [
			vendor,
			dynamicDateRange,
			vendor === EVendorsValues.oran,
			dynamicDateRange !== EDynamicDateRange.custom || startDateOffset !== undefined,
		],
		allowedRoles: [
			EUserRoles.networkOperatorKpiUpdater,
			EUserRoles.networkOperatorKpiViewer,
		],
		refetchOnWindowFocus: false,
	});

	return {
		dateRangePreview: data?.dateRangePreview || '',
		isLoadingDateRangePreview: isLoadingDynamicDatesPreview && isFetchingDynamicDatesPreview,
	};
};
